<template>
  <div>
    <layout-loading v-if="isSubmit" />
    <changeLanguageHeaderTable
      :current-language="currentLanguage"
      @change-language="changeLanguage"
    />

    <BDataTable
      ref="refTable"
      :fetch-list="fetchList"
      :table-columns="tableColumns"
      @onGroupDelete="groupDelete"
    >
      <!-- Column: Type -->
      <template #cell(type)="{ item }">
        {{ item.type && item.type.title }}
      </template>

      <!-- Column: IsActive -->
      <template #cell(isActive)="{ item }">
        <feather-icon
          v-if="item.isActive"
          icon="CheckIcon"
          color="#28a745"
          size="22"
        />
      </template>

      <!-- Column: Link -->
      <template #cell(link)="{ item }">
        <b-link
          v-b-tooltip
          :href="item.link"
          target="_blank"
          :title="item.link"
        >
          <feather-icon
            icon="LinkIcon"
            size="20"
            opacity=".8"
          />
          {{ item.linkTitle[currentLanguage] }}</b-link>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="{ item }">
        <edit-row @click.native="toEditPage(item._id)" />
        <delete-row @click.native="deleteItem(item._id)" />
      </template>
    </BDataTable>
  </div>
</template>

<script>
import { BLink, VBTooltip } from 'bootstrap-vue'
import changeLanguageHeaderTable from '@/components/change-language-header-table.vue'
import BDataTable from '@/components/BDataTable/index.vue'
import EditRow from '@/components/BDataTable/Actions/EditRow.vue'
import DeleteRow from '@/components/BDataTable/Actions/DeleteRow.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import useNotificationsList from './useNotificationsList'

export default {
  name: 'NotificationsList',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BDataTable,
    BLink,
    DeleteRow,
    LayoutLoading,
    EditRow,
    changeLanguageHeaderTable,
  },
  setup() {
    const {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    } = useNotificationsList()

    return {
      changeLanguage,
      currentLanguage,
      deleteItem,
      fetchList,
      groupDelete,
      isSubmit,
      refTable,
      tableColumns,
      toEditPage,
    }
  },
}
</script>
